  $(document).ready(function(){
    
    var classes = ['starting-from-top','starting-from-right', 'starting-from-bottom', 'starting-from-left'];
    var randomnumber = Math.floor(Math.random()*classes.length);
    var promotionPopup = $('#promotion-popup');
    var wrapperContainer = $('.wrapper-container');
    var linkToPromotionPopup = $('.link-to-promotion-popup');
    var btnClosePopup = promotionPopup.find('.btn-close');
    var btnBgClosePopup = wrapperContainer.find(".wrap-overlay");
    var PopupFirstContent = promotionPopup.find('.content-first');
    var PopupSecondContent = promotionPopup.find('.content-second');
    var PopupLastContent = promotionPopup.find('.content-last');
    var btnPopupFirstContent = PopupFirstContent.find('button');
    var btnPopupSecondContent = PopupSecondContent.find('button');
    
    promotionPopup.addClass(classes[randomnumber]);
    promotionPopup.css('display','block');
    
   
    linkToPromotionPopup.click(function(){
      wrapperContainer.removeClass('menu-open');
      promotionPopup.addClass('active');
      wrapperContainer.addClass('event-popup-open');
      $("#main-popup").css("display","none");
      
    });
   
    
    btnClosePopup.click(function(){
      promotionPopup.removeClass('active');
      wrapperContainer.removeClass('event-popup-open');
      window.setTimeout(function(){
        var randomClasses = ['starting-from-right', 'starting-from-bottom', 'starting-from-left','starting-from-top'];
        var randomnumber = Math.floor(Math.random()*classes.length);
        promotionPopup.attr('class', 'promotion-popup');
        promotionPopup.css('display','none');
        promotionPopup.addClass(randomClasses[randomnumber]);
      }, 150);
      window.setTimeout(function(){
        promotionPopup.css('display','block');
        PopupFirstContent.css('display','block');
        PopupSecondContent.css('display','none');
        PopupLastContent.css('display','none');
      }, 200);
    });
    
    btnBgClosePopup.click(function(){
      promotionPopup.removeClass('active');
      wrapperContainer.removeClass('event-popup-open');
      window.setTimeout(function(){
        var randomClasses = ['starting-from-right', 'starting-from-bottom', 'starting-from-left','starting-from-top'];
        var randomnumber = Math.floor(Math.random()*classes.length);
        promotionPopup.attr('class', 'promotion-popup');
        promotionPopup.css('display','none');
        promotionPopup.addClass(randomClasses[randomnumber]);
      }, 150);
      window.setTimeout(function(){
        promotionPopup.css('display','block');
        PopupFirstContent.css('display','block');
        PopupSecondContent.css('display','none');
        PopupLastContent.css('display','none');
      }, 200);
    });
    
    
    /*PopupFirstContent.click(function(){
      $(this).css('display','none');
      PopupSecondContent.css('display','block');
    }); 
    */
    btnPopupFirstContent.click(function(){
      $(this).parent().css('display','none');
      PopupSecondContent.css('display','block');
    });

    PopupSecondContent.click(function(){
      $(this).css('display','none');
      PopupFirstContent.css('display','block');
    });

    var time = new Date().getTime();
    var src = 'https://cdn.shopify.com/s/files/1/0260/5701/5382/files/no_bt.gif?v=1612176084?time=' + time;
    $('.btn-nope').hover(
      function(){
        $('#imgNope').attr('src', src);
      }
    );
    
    $('.promotion-popup .contents select').on('change',function(){
        var categorylink = '/collections/main'
        var nextBtn = $('.promotion-popup button');
      
      	nextBtn.addClass('active');
        nextBtn.click(function(){
          location.href = categorylink;
      });
    	
    });
    
  });